import * as types from './mutation-types';

const findIndex = (arr, id) => arr.findIndex(obj => obj.id === id);
const findMovimentacaoIndexes = (items, movimentacao) => {
  let index_item = null;
  let index_lote = null;
  items.forEach((item, i) => {
    item.lotes.forEach((lote, j) => {
      if (lote.id === movimentacao.lote_id) {
        index_item = i;
        index_lote = j;
      }
    });
  });
  return { index_item, index_lote };
};

export const SET_TIPO_AGENDA = ({ commit }, tipo) => commit(types.SET_TIPO_AGENDA, tipo);

export const SET_FILTRO_VENDA = ({ commit }, filtro_venda) => commit(types.SET_FILTRO_VENDA, filtro_venda);
export const SET_FILTRO_COMPRA = ({ commit }, filtro_compra) => commit(types.SET_FILTRO_COMPRA, filtro_compra);
export const SET_FILTRO_LOTE = ({ commit }, filtro_lote) => commit(types.SET_FILTRO_LOTE, filtro_lote);

export const CLEAR_STATE = ({ commit }) => commit(types.CLEAR_STATE);
export const CONTEXTO = ({ commit }, contexto) => commit(types.CONTEXTO, contexto);
export const LOCALIZACAO = ({ commit }, localizacao) => commit(types.LOCALIZACAO, localizacao);
export const AVATAR_BASE64 = ({ commit }, base_64) => commit(types.AVATAR_BASE64, base_64);

export const SHOW_SNACKBAR = ({ commit }, config) => commit(types.SNACKBAR, config);
export const HIDE_SNACKBAR = ({ commit }) => commit(types.SNACKBAR, { visible: false });

export const SET_ITEMS = ({ commit }, items) => commit(types.SET_ITEMS, items);
export const UNSET_ITEMS = ({ commit }) => commit(types.UNSET_ITEMS);
export const ITEMS_ADD = ({ commit, state }, item) => commit(types.ITEMS_ADD, { items: state.items, item });
export const ITEMS_DEL = ({ commit, state }, item) => commit(types.ITEMS_DEL, { items: state.items, item });

export const LOTE_ADD = ({ commit, state }, lote) => {
  const i = findIndex(state.items, lote.produto_id);
  return commit(types.ITEMS_ADD, { items: state.items[i].lotes, item: lote });
};
export const LOTE_DEL = ({ commit, state }, lote) => {
  const i = findIndex(state.items, lote.produto_id);
  return commit(types.ITEMS_DEL, { items: state.items[i].lotes, item: lote });
};
export const MOVIMENTACAO_ADD = ({ commit, state }, movimentacao) => {
  const { index_item, index_lote } = findMovimentacaoIndexes(state.items, movimentacao);
  return commit(types.ITEMS_ADD, { items: state.items[index_item].lotes[index_lote].movimentacoes, item: movimentacao });
};
export const MOVIMENTACAO_DEL = ({ commit, state }, movimentacao) => {
  const { index_item, index_lote } = findMovimentacaoIndexes(state.items, movimentacao);
  return commit(types.ITEMS_DEL, { items: state.items[index_item].lotes[index_lote].movimentacoes, item: movimentacao });
};
export const SHOW_NOTIFICATION = ({ commit }, config) => commit(types.NOTIFICATION, config);
export const HIDE_NOTIFICATION = ({ commit }) => commit(types.NOTIFICATION, { visible: false });
